import jobTitlesApi from 'Api/axios/job-titles-api';
import { useState, useEffect } from 'react';
import type { JobTitleFilterI, JobTitleI } from 'types';

interface Props {
  init?: boolean;
}

const useJobTitlesApi = ({ init = false }: Props = {}) => {
  const [data, setData] = useState<Array<JobTitleI>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchJobTitles = async (filters: JobTitleFilterI = {}) => {
    setLoading(true);
    const response = await jobTitlesApi.readAll(filters);
    setData(response.data ?? []);
    setLoading(false);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchJobTitles();
    }
  }, [init]);

  return {
    data,
    loading,
    error,
    fetchJobTitles,
  };
};

export default useJobTitlesApi;
